'use strict';

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  tagName: 'li',
  className: 'staff-list-employee',
  template: require('./templates/list-item.hbs'),

  ui: {
    back: '.staff-list-employee-back',
    next: '.staff-list-employee-next',
    name: '.staff-list-employee-name',
  },

  events: {
    'click @ui.name': 'onClickEmployee',
    'click @ui.back': 'onClickBack',
    'click @ui.next': 'onClickNext',
  },

  onClickEmployee: function (evt) {
    evt.preventDefault();
    this.triggerMethod('click', this.model);
  },

  onClickBack: function (evt) {
    evt.preventDefault();
    this.triggerMethod('back');
  },

  onClickNext: function (evt) {
    evt.preventDefault();
    this.triggerMethod('next');
  },

  select: function () {
    this.$el.addClass('active');
    if (window.SETTINGS.show_staff_picker) {
      this.ui.name.focus();
    }
  },

  deselect: function () {
    this.$el.removeClass('active');
  },

});
